import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";

export const layoutRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "layout/$layoutId",
}).lazy(() => import("./LayoutEditor.lazy").then((d) => d.Route));
